import { ReactNode, ButtonHTMLAttributes, FC } from 'react';
import classNames from 'classnames';
import { Spinner } from 'react-bootstrap';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  onClick?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
  iconName?: string;
  iconRight?: string;
}

const Button: FC<ButtonProps> = ({
  children = '',
  onClick = () => {},
  isLoading = false,
  disabled = false,
  className = '',
  iconName = '',
  iconRight = '',
  ...restProps
}) => {
  const combinedClassName = classNames('main-button', {
    [className]: !!className,
  });

  return (
    <button
      type={restProps.type || 'button'}
      className={combinedClassName}
      onClick={onClick}
      disabled={isLoading || disabled}
      {...restProps}
    >
      {iconName && <i className={iconName} />}
      {children}
      {isLoading && <Spinner variant="primary" className="spinner" animation="border" />}
      {iconRight && <i className={iconRight} />}
    </button>
  );
};

export default Button;
